module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG70c217648c0e5f024e912dad8c2bba28.70c21764.png";